import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';
import { useToast } from './use-toast';

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast
            key={id}
            {...props}
            className={`${props.className} ${
              props.variant === 'default'
                ? 'bg-green-500 text-white border-green-600'
                : props.variant === 'destructive'
                  ? 'bg-red-500 text-white border-red-600'
                  : ''
            } py-4`}
          >
            <div className='grid gap-0.5 w-full'>
              {title && <ToastTitle className='text-sm font-medium'>{title}</ToastTitle>}
              {description && (
                <ToastDescription className='text-xs'>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose className='h-4 w-4' />
          </Toast>
        );
      })}
      <ToastViewport className='fixed top-0 right-0 flex flex-col p-2 gap-2 w-auto max-w-[100%] max-h-screen z-[100]' />
    </ToastProvider>
  );
}
